module.exports = __webpack_public_path__ + "static/media/feedback.5a6ac08d.png";